/* eslint-disable @atlaskit/design-system/use-primitives-text */
/* eslint-disable @atlassian/i18n/no-literal-string-in-jsx */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import {
	AUTHENTICATE_COMMAND,
	INSTALL_SKILLS_COMMAND,
	INSTRUCTION_1,
	INSTRUCTION_2,
	INSTRUCTION_3,
	INSTRUCTION_4,
	VERIFY_INSTALLATION_COMMAND,
} from './constants';

const styles = cssMap({
	body: {
		width: '100%',
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
		padding: '40px',
		margin: 0,
		font: token('font.body.large'),
		fontFamily: token('font.family.code'),
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
		lineHeight: '24px',
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
		letterSpacing: '0.2px',
		whiteSpace: 'pre-wrap',
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
		color: '#6C6F77',
	},
	command: {
		display: 'block',
		width: '100%',
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
		color: '#DDDEE1',
	},
});

const MACOS_INSTALL_COMMAND = `bash <(curl -fsSL https://teamwork-graph.atlassian.com/cli/install)`;

export const MacOSTerminalBody = (): JSX.Element => (
	<pre css={styles.body}>
		{INSTRUCTION_1}
		<span css={styles.command}>{MACOS_INSTALL_COMMAND}</span>
		{'\n'}
		{INSTRUCTION_2}
		<span css={styles.command}>{VERIFY_INSTALLATION_COMMAND}</span>
		{'\n'}
		{INSTRUCTION_3}
		<span css={styles.command}>{AUTHENTICATE_COMMAND}</span>
		{'\n'}
		{INSTRUCTION_4}
		<span css={styles.command}>{INSTALL_SKILLS_COMMAND}</span>
	</pre>
);
